import { AvaliacaoList, ResultadoToShow } from './../../models/avaliacao.model';
import { HelpersService } from 'src/app/services/helpers.service';
import { DatabaseService } from './../../services/database.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resultado',
  templateUrl: './resultado.component.html',
  styleUrls: ['./resultado.component.css']
})
export class ResultadoComponent implements OnInit {

  showSpinner = true;
  liberarResultado = this.helpers.hackathonLiberarResultado;
  private resultados: ResultadoToShow[] = [];

  constructor(private database: DatabaseService,
              private helpers: HelpersService) { }

  ngOnInit(): void {
    this.database.getAvaliacoes(this.helpers.hackathonId)
    .then(rawData => rawData.subscribe((avaliacoes: AvaliacaoList[]) => {
      avaliacoes.forEach(avaliacao => {
        avaliacao.equipesAvaliadas.forEach(equipe => {

          let notaTotalEquipe = 0;
          equipe.avaliacoes.forEach(entrega => {
            notaTotalEquipe += entrega.pontuacao;
          });
          this.adicionarResultado({ nomeEquipe: equipe.nomeEquipe, nota: notaTotalEquipe });

        });
      });

      this.showSpinner = false;
    }));
  }

  private adicionarResultado(equipe: ResultadoToShow): void {
    const equipeIndex = this.resultados.findIndex(resultado => resultado.nomeEquipe === equipe.nomeEquipe);

    if (equipeIndex > -1) {
      this.resultados[equipeIndex].nota += equipe.nota;
    } else {
      this.resultados.push(equipe);
    }

    this.resultados.sort((a, b) => a.nota + b.nota);
  }

  getResultado() {
    return this.resultados;
  }

}
